import { useEffect, useState } from 'react';
import { getPodProductConfiguration, type PodLocation } from '../pod';

interface UsePoDProductConfigurationArgs {
  extProductId?: string | null;
  divisionId?: string;
  enabled?: boolean;
}

export function usePoDProductConfiguration({
  extProductId,
  divisionId,
  enabled = true,
}: UsePoDProductConfigurationArgs) {
  const [productLocations, setProductLocations] = useState<PodLocation[]>([]);
  const [loading, setLoading] = useState<boolean>(enabled && Boolean(extProductId));
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    // async guard to avoid state updates after the component has been unmounted
    let cancelled = false;

    if (!enabled || !extProductId) {
      setProductLocations([]);
      setLoading(false);
      setError(false);
      return;
    }

    setLoading(true);
    setError(false);

    getPodProductConfiguration({ extProductId, divisionId })
      .then((result) => {
        if (!cancelled) {
          setProductLocations(result.locations ?? []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setProductLocations([]);
          setError(true);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [divisionId, enabled, extProductId]);

  return { productLocations, loading, error };
}
